import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import * as Parse from 'parse';

@Injectable()
export class ErrorHandlerService {

    constructor(private router: Router) {

    }

    handleInvalidSessionError(error: any) {
        const url: string = this.router.url;

        switch (error.code) {
            case Parse.Error.INVALID_SESSION_TOKEN:
            void Parse.User.logOut();
            window.location.replace(`${window.location.origin}/login?sessionExpired=true&redirectTo=${encodeURI(url)}`);

            break;
        }
    }

    handleAuthenticationErrors(error: any) {
        if (error.code === Parse.Error.OBJECT_NOT_FOUND) {
            return 'Invalid Credentials. Email or Password incorrect.';
        } else if (error.code === Parse.Error.EMAIL_NOT_FOUND) {
            return 'Email not verified. Please verify your email before logging in.';
        } else if (error.code === Parse.Error.OTHER_CAUSE) {
            return 'Your account has been deactivated.';
        } else {
            return 'An error occurred during login.';
        }
    }
}
